// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__xP+2X"};